import React, { useEffect, useState } from "react";
import { Divider, Form } from "antd";
import logo from "../../assets/images/payment_logo.png"
import metamask from "../../assets/images/metamask.svg"
import rightArrow from "../../assets/images/right_arrow.svg"
import CopyToClipboard from "react-copy-to-clipboard";
import AppText from "../../shared/appText";
import { geCustomertPaymentDetails } from "./service";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import QRCodeComponent from "../shared.component/qrCodeComponent";
import Loader from "../../shared/loader";
import AppAlert from "../../shared/appAlert";
import NumberFormat from "react-number-format";

const PaymentMethod = () => {
  const[loading,setLoading] = useState(false);
  const[details,setDetails] = useState([]);
  const[errorMessage,setErrorMessage] = useState(null);
  const { pathname } = useLocation();
  const _id = pathname?.split('/')[2];
  useEffect(() =>{
    getDetails();
  },[])
  const getDetails = async() =>{
    try{
      setLoading(true);
      let response = await geCustomertPaymentDetails('Merchant/PaymentDetail',_id);
      if(response){
        setDetails(response);
      }
    }catch(error){
      setErrorMessage(error)
    }
    finally{
      setLoading(false);
    }
}
  return (
    <div className="page-White">
             {loading  && <Loader/>}
      {errorMessage && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={errorMessage}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() => setErrorMessage(null)}></span>
            </div>
        )}
     <div className="payment-section">
    <div className="logo-flex"><img className="logo-style" src={logo} /><h3>{details?.merchantName}</h3></div>
    <div className="cust-qr" >
                  <QRCodeComponent size={200} value={details?.walletAddress}/>
                    </div>
    <div className="">
    <CopyToClipboard text={"1FfmbHfnpaZjKFvyi1okT...jaPH"} options={{ format: 'text/plain' }}><AppText copyable={{ tooltips: ['Copy', 'Copied'] }} className="address-text">1FfmbHfnpaZjKFvyi1okT...jaPH</AppText></CopyToClipboard>
    </div>
    <p className="balance-text mx-6">  <NumberFormat  value={parseFloat(details?.amount).toFixed(2)} displayType="text" thousandSeparator={true} /> {" "} {details?.currency}</p>
    <p className="balance-text"><span className="text-gray">Order Id :</span> <span>{details?.orderId || "--"}</span></p>
    <Divider plain className="text-black">OR</Divider>
    <h4>Select  Payment method</h4>
    <div className="metamask-connect">
    <div className="d-flex align-items-center gap-8">

      <img  src={metamask} />
    <p>Metamask Wallet</p></div>
      <img  src={rightArrow} />
    </div>
    <Divider plain className="text-black">OR</Divider>
    <h4 className="mb-18">After payment completion</h4>
        <Form.Item
          className=""
          name="amount"
          label="Email"
          colon={false}
          required
        >
          <input
            className=""
            placeholder="Enter Email"
            type="input"
            maxLength={150}
          />
        </Form.Item>
        <Form.Item
          className=""
          name="amount"
          label="hash"
          colon={false}
          required
        >
          <input
            className=""
            placeholder="Enter hash"
            type="input"
            maxLength={150}
          />
        </Form.Item>
        <button className="submit-btn">Submit</button>
     </div>
    </div>
  );
};

export default PaymentMethod;
